/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.number(),
  createdAt: z.number(),
  updatedAt: z.number(),
  material_division_id: z.number(),
  material_id: z.number(),
  definition_name: z.string(),
  temperature_lower: z.number().nullable(),
  temperature_upper: z.number().nullable(),
  pot_life_minutes: z.number().nullable(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.number() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const PotLifeSpecBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type PotLifeSpecBase = z.infer<typeof base>;
export type PotLifeSpecBasePutPayload = z.infer<typeof put>;
export type PotLifeSpecBasePatchPayload = z.infer<typeof patch>;
export type PotLifeSpecBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type PotLifeSpecBaseCreateAttributes = z.infer<typeof create>;
export type PotLifeSpecBaseUpdateAttributes = z.infer<typeof update>;
export type PotLifeSpecBaseCacheAttributes = z.infer<typeof cache>;
export type PotLifeSpecBaseCachesAttributes = z.infer<typeof caches>;